import { FC, memo } from 'react'

import { Form } from 'brief-form'
import { Select } from 'ui/components/Select'
import { FilterPanel } from 'ui/components/Table'

import { FilterProps } from './FilterProps'

import { FormBox, SelectWrapper } from './styles'

export const Filter: FC<FilterProps> = memo((props) => {
  const {
    form: { config, isDirty, Field },
    expanded,
    onToggle,
    webPage,
    onClear
  } = props

  return (
    <FilterPanel isDirty={isDirty} onReset={onClear} expanded={expanded} onToggle={onToggle}>
      <Form config={config}>
        <FormBox>
          <SelectWrapper>
            <Field
              name="internal"
              label="Internal"
              input={Select}
              inputProps={{
                data: webPage.internalOptions
              }}
            />
          </SelectWrapper>
          <SelectWrapper>
            <Field
              name="frequency"
              label="Frequency"
              input={Select}
              inputProps={{
                data: webPage.frequencyOptions
              }}
            />
          </SelectWrapper>
          <SelectWrapper>
            <Field
              name="alerts"
              label="Alerts"
              input={Select}
              inputProps={{
                data: webPage.alertsOptions
              }}
            />
          </SelectWrapper>
        </FormBox>
      </Form>
    </FilterPanel>
  )
})
